<template>
  <div>
    <div
      class="courseSectionContainer"
      v-for="program of programs"
      v-bind:key="program.id"
    >
      <div class="courseHeader">
        <b class="courseTitle">{{ program.name }} Pilot</b>
      </div>
      <div class="cardsContainer">
        <ClassCards
          v-for="classObj of classes.filter(
            (data) => data.curriculum.programId === program.id,
          )"
          v-bind:key="classObj.id"
          :course="classObj"
        />
      </div>
    </div>
  </div>
</template>
<script>
import ClassCards from "@/pages/Dashboard/HiloPages/Classroom/ClassCards.vue";
import ClassesAPIService from "../../../servicehandlers/ClassesAPIService";
const classesAPIService = new ClassesAPIService();
import ProgramsAPIService from "../../../servicehandlers/ProgramsAPIService";
const programsAPIService = new ProgramsAPIService();

export default {
  name: "Frame",
  components: { ClassCards },
  data() {
    return {
      classes: [],
      programs: [],
    };
  },
  mounted() {
    this.getClasses();
    this.getPrograms();
  },
  methods: {
    getClasses() {
      return classesAPIService
        .getArchiveClasses(this.$router)
        .then((response) => {
          for (let classObj of response) {
            classObj.startDate = new Date(classObj.startDate);
            classObj.endDate = new Date(classObj.archiveEndDate);
            classObj.students = classObj.archivedClassStudentMaps;
            let total = 0;
            for (let student of classObj.students) {
              total += student.averageGrade;
            }
            classObj.averageGrade = total / classObj.students.length;
          }

          this.classes = response;
        });
    },
    getPrograms() {
      return programsAPIService.get(this.$router).then((response) => {
        this.programs = response;
      });
    },
  },
};
</script>
<style scoped>
.courseTitle {
  width: 300px;
  position: relative;
  font-size: 25px;
  display: inline-block;
  color: #404040;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 0;
}
.courseHeader {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px;
  gap: 10px;
}
.cardsContainer {
  display: flex;
  gap: 30px;
  overflow-x: auto;
  padding-bottom: 10px;
  width: 100%;
  scroll-snap-type: x mandatory;
  flex-direction: row;
}

.cardsContainer > * {
  flex: 0 0 calc(33.333% - 20px);
  scroll-snap-align: start;
}

.unassignedCards > * {
  flex: 0 0 calc(50% - 20px);
  scroll-snap-align: start;
}

.cardsContainer::-webkit-scrollbar {
  height: 8px;
}

.cardsContainer::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.cardsContainer::-webkit-scrollbar-track {
  background: transparent;
}

@media (max-width: 768px) {
  .cardsContainer {
    gap: 20px;
  }
}
.courseSectionContainer {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 50px;
  gap: 20px;
  z-index: 6;
}
</style>
